(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ascend-landing"] && !Shopify.designMode) return;
  try {
    
  const ascendSuccess = document.querySelector('[data-ascend-success]');
  if (ascendSuccess) {
    ascendSuccess.focus({ preventScroll: true });
    ascendSuccess.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ascend-product"]) return;
  try {
    
  document.querySelectorAll('[data-ascend-product]').forEach((root) => {
    const gallery = root.querySelector('[data-ascend-gallery]');
    if (gallery) {
      const stage = gallery.querySelector('[data-ascend-gallery-stage]');
      const slides = Array.from(gallery.querySelectorAll('[data-ascend-gallery-slide]'));
      const thumbnails = Array.from(gallery.querySelectorAll('[data-ascend-gallery-thumbnail]'));
      const count = gallery.querySelector('[data-ascend-gallery-count]');
      const previous = gallery.querySelector('[data-ascend-gallery-previous]');
      const next = gallery.querySelector('[data-ascend-gallery-next]');
      let currentIndex = 0;
      let pointerStartX = null;

      const showImage = (requestedIndex) => {
        if (slides.length < 2) return;
        currentIndex = (requestedIndex + slides.length) % slides.length;
        slides.forEach((slide, index) => {
          const active = index === currentIndex;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        thumbnails.forEach((thumbnail, index) => {
          const active = index === currentIndex;
          thumbnail.classList.toggle('is-active', active);
          thumbnail.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        if (count) count.textContent = `${currentIndex + 1} / ${slides.length}`;
      };

      if (slides.length > 1) {
        gallery.classList.add('is-ready');
        thumbnails.forEach((thumbnail) => {
          thumbnail.addEventListener('click', () => showImage(Number(thumbnail.dataset.galleryIndex)));
        });
        previous?.addEventListener('click', () => showImage(currentIndex - 1));
        next?.addEventListener('click', () => showImage(currentIndex + 1));
        stage?.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            showImage(currentIndex - 1);
          }
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            showImage(currentIndex + 1);
          }
        });
        stage?.addEventListener('pointerdown', (event) => {
          if (event.target.closest('button')) return;
          event.preventDefault();
          pointerStartX = event.clientX;
          stage.setPointerCapture?.(event.pointerId);
        });
        stage?.addEventListener('pointerup', (event) => {
          if (pointerStartX === null) return;
          const distance = event.clientX - pointerStartX;
          pointerStartX = null;
          if (stage.hasPointerCapture?.(event.pointerId)) stage.releasePointerCapture(event.pointerId);
          if (Math.abs(distance) < 45) return;
          showImage(currentIndex + (distance < 0 ? 1 : -1));
        });
        stage?.addEventListener('pointercancel', () => {
          pointerStartX = null;
        });
      }
    }

    const select = root.querySelector('[data-ascend-variant-select]');
    const price = root.querySelector('[data-ascend-price]');
    const submit = root.querySelector('[data-ascend-submit]');
    if (select && price && submit) {
      select.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        const available = option?.dataset.available === 'true';
        if (option?.dataset.price) price.textContent = option.dataset.price;
        submit.disabled = !available;
        submit.textContent = available ? 'Legg i handlekurven' : 'Utsolgt';
        const url = new URL(window.location.href);
        url.searchParams.set('variant', select.value);
        window.history.replaceState({}, '', url);
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.querySelectorAll('[data-cookie-preferences]').forEach((button) => {
    button.addEventListener('click', async () => {
      try {
        if (window.privacyBanner?.showPreferences) {
          await window.privacyBanner.showPreferences();
          return;
        }
        if (window.Shopify?.customerPrivacy?.showPreferences) {
          window.Shopify.customerPrivacy.showPreferences();
          return;
        }
        const legacyTrigger = document.querySelector('#shopify-pc__banner__btn-manage-prefs');
        if (legacyTrigger) {
          legacyTrigger.click();
          return;
        }
      } catch (error) {
        console.warn('Kunne ikke åpne innstillinger for informasjonskapsler.', error);
      }
      window.location.assign(button.dataset.privacyPolicyUrl || '/policies/privacy-policy');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.querySelectorAll('[data-mobile-menu]').forEach((menu) => {
    const summary = menu.querySelector('summary');
    const panel = menu.querySelector('.mobile-menu__panel');
    const pageContent = [
      document.querySelector('main'),
      document.querySelector('footer'),
      menu.parentElement?.querySelector('.wordmark'),
      menu.parentElement?.querySelector('.desktop-nav'),
      menu.parentElement?.querySelector('.header-actions'),
      document.querySelector('#shopify-pc__banner'),
      document.querySelector('#shopify-pc__prefs'),
      document.querySelector('[data-newsletter-popup]')
    ].filter(Boolean);

    const setPageInert = (isInert) => {
      pageContent.forEach((element) => {
        element.toggleAttribute('inert', isInert);
        if (element.matches('main, footer')) {
          if (isInert) element.setAttribute('aria-hidden', 'true');
          else element.removeAttribute('aria-hidden');
        }
      });
      document.documentElement.classList.toggle('mobile-menu-is-open', isInert);
    };

    const focusableItems = () => [
      summary,
      ...menu.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')
    ].filter((element, index, items) => items.indexOf(element) === index && !element.hasAttribute('inert'));

    menu.addEventListener('toggle', () => {
      summary?.setAttribute('aria-label', menu.open ? summary.dataset.closeLabel : summary.dataset.openLabel);
      summary?.setAttribute('aria-expanded', String(menu.open));
      setPageInert(menu.open);
      if (menu.open) {
        const firstLink = panel?.querySelector('a[href]');
        firstLink?.focus({ preventScroll: true });
        requestAnimationFrame(() => firstLink?.focus({ preventScroll: true }));
      }
    });
    menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => {
      menu.removeAttribute('open');
      setPageInert(false);
    }));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && menu.open) {
        menu.removeAttribute('open');
        setPageInert(false);
        summary?.focus();
        return;
      }
      if (event.key === 'Tab' && menu.open) {
        const items = focusableItems();
        const first = items[0];
        const last = items[items.length - 1];
        const activeIndex = items.indexOf(document.activeElement);
        if (activeIndex === -1) {
          event.preventDefault();
          (event.shiftKey ? last : first)?.focus();
        } else if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last?.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first?.focus();
        }
      }
    });

    document.addEventListener('focusin', (event) => {
      if (menu.open && !menu.contains(event.target)) {
        panel?.querySelector('a[href]')?.focus({ preventScroll: true });
      }
    });

    window.addEventListener('pageshow', () => {
      if (!menu.open) setPageInert(false);
    });
  });

  const sectionLinks = [...document.querySelectorAll('[data-section-link]')];
  const sectionIds = [...new Set(sectionLinks.map((link) => link.dataset.sectionLink))];
  const observedSections = sectionIds.map((id) => document.getElementById(id)).filter(Boolean);
  if (observedSections.length && 'IntersectionObserver' in window) {
    const navigationObserver = new IntersectionObserver((entries) => {
      const visible = entries.filter((entry) => entry.isIntersecting).sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
      if (!visible) return;
      sectionLinks.forEach((link) => {
        const active = link.dataset.sectionLink === visible.target.id;
        link.classList.toggle('is-active', active);
        if (active) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });
    }, { rootMargin: '-25% 0px -60% 0px', threshold: [0, .25, .5] });
    observedSections.forEach((section) => navigationObserver.observe(section));
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.querySelectorAll('[data-product-section]').forEach((section) => {
    const dialog = section.querySelector('[data-product-zoom-dialog]');
    if (!dialog) return;

    const triggers = Array.from(section.querySelectorAll('[data-product-zoom-open]'));
    const image = dialog.querySelector('[data-product-zoom-image]');
    const closeButton = dialog.querySelector('[data-product-zoom-close]');

    const transition = (update) => {
      if (document.startViewTransition) {
        document.startViewTransition(update);
      } else {
        update();
      }
    };

    const showImage = (trigger) => {
      image.src = trigger.dataset.productZoomSrc;
      image.width = Number(trigger.dataset.productZoomWidth) || 960;
      image.height = Number(trigger.dataset.productZoomHeight) || 960;
      image.alt = trigger.dataset.productZoomAlt;
    };

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        showImage(trigger);
        transition(() => dialog.showModal());
      });
    });

    closeButton.addEventListener('click', () => transition(() => dialog.close()));
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) transition(() => dialog.close());
    });
    dialog.addEventListener('close', () => image.removeAttribute('src'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"]) return;
  try {
    
  document.querySelectorAll('[data-newsletter-popup]').forEach((popup) => {
    const storageKey = popup.dataset.storageKey;
    const success = popup.querySelector('[data-newsletter-popup-success]');
    const errors = popup.querySelector('[data-newsletter-popup-errors]');
    const closeButton = popup.querySelector('[data-newsletter-popup-close]');
    const footerSuccess = document.querySelector('[data-footer-newsletter-success]');
    const snoozeDuration = 7 * 24 * 60 * 60 * 1000;
    let privacyRetry;
    let storedValue = '';

    try {
      storedValue = window.localStorage.getItem(storageKey) || '';
    } catch (error) {
      storedValue = '';
    }

    const openPopup = () => {
      if (popup.open) return;
      if (typeof popup.showModal === 'function') {
        popup.showModal();
      } else {
        popup.setAttribute('open', '');
      }
    };

    const privacyUiVisible = () => {
      const privacyElements = document.querySelectorAll('#shopify-pc__banner, #shopify-pc__prefs');
      return Array.from(privacyElements).some((element) => {
        return element.getAttribute('aria-hidden') !== 'true' && element.getClientRects().length > 0;
      });
    };

    const openWhenPrivacyReady = () => {
      if (privacyUiVisible()) {
        privacyRetry = window.setTimeout(openWhenPrivacyReady, 750);
        return;
      }
      openPopup();
    };

    const remember = (value) => {
      try {
        window.localStorage.setItem(storageKey, value);
      } catch (error) {
        return;
      }
    };

    const closePopup = () => {
      if (privacyRetry) window.clearTimeout(privacyRetry);
      if (!success) remember(String(Date.now()));
      if (typeof popup.close === 'function') {
        popup.close();
      } else {
        popup.removeAttribute('open');
      }
    };

    if (success || footerSuccess) {
      remember('subscribed');
    }

    if (success || errors) {
      openWhenPrivacyReady();
    } else if (!footerSuccess && storedValue !== 'subscribed') {
      const dismissedAt = Number(storedValue);
      const isSnoozed = Number.isFinite(dismissedAt) && dismissedAt > 0 && Date.now() - dismissedAt < snoozeDuration;
      if (!isSnoozed) window.setTimeout(openWhenPrivacyReady, Number(popup.dataset.delay) || 0);
    }

    closeButton?.addEventListener('click', closePopup);
    popup.addEventListener('cancel', (event) => {
      event.preventDefault();
      closePopup();
    });
    popup.addEventListener('click', (event) => {
      if (event.target === popup) closePopup();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sokkloft-home"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-sl-height-form]').forEach((form) => {
    const submit = form.querySelector('[data-sl-height-submit]');
    const options = Array.from(form.querySelectorAll('[data-sl-height-option]'));
    const price = form.querySelector('[data-sl-height-price]');
    const syncSubmit = () => {
      const selectedOption = options.find((input) => input.checked);
      const hasSelection = Boolean(selectedOption);
      submit.disabled = !hasSelection;
      submit.textContent = hasSelection ? submit.dataset.selectedLabel : submit.dataset.unselectedLabel;
      if (selectedOption && price) price.textContent = selectedOption.dataset.price || price.textContent;
    };

    options.forEach((input) => input.addEventListener('change', syncSubmit));
    syncSubmit();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["theme-styles"]) return;
  try {
    
  const revealItems = document.querySelectorAll('[data-reveal]');
  const revealAllItems = () => revealItems.forEach((item) => item.classList.add('is-visible'));
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const revealObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    revealItems.forEach((item) => revealObserver.observe(item));
    window.setTimeout(revealAllItems, 1800);
  } else {
    revealAllItems();
  }

  } catch(e) { console.error(e); }
})();
})();
